import React, { Component } from 'react';
import { Header, Segment, Grid, Form, Button, Icon, Table, Divider ,Dropdown,Message,Label,LabelDetail,Popup} from "semantic-ui-react"
import {BASE_URL} from "../../../constants/app_routes";
import { getInspectionByDate } from '../../../data/inspection_api';
import { getPropertyVisitsByDate } from '../../../data/dashboard_api';
import { DASHBOARD_API_URL, INSPECTION_API_URL, PROPERTY_VISIT_API_URL } from '../../../constants/api_routes';
import moment from 'moment';
import html2canvas from 'html2canvas';
import {handleFileDownload} from "../../../utils/download_file";
import DownloadingIntent from "../../universal/toast";
import { uploadExpenseForm, uploadExpenseImages,getExpenseFormList,deleteExpenseForm, getExpenseImage } from '../../../data/dashboard_api';
import * as fileIcon from "../../../assets/fileIcon.png";
const uuidv1 = require('uuid/v1');
export default class ClerkExpensesGenerator extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dateRange:undefined,
            tableEntries:[],
            filesToUpload:[],
            loadingInspections:false,
            totals:[0,0,0,0,0,0,0,0,0,0],
            formName:undefined,
            formID:undefined,
            dropdownOptions:[],
            currentSelection:undefined,
            loading:true,
            monthConfirmed:false,
            unsaved:false,
            imageUpload:false,
            pdfNotif:false,
            genPic:undefined,
            username:""
        };
    }
    // ["26/07/2024","123 Highway Street","Extra coffee",0,0,0,0,undefined,undefined,undefined]
    componentDidMount(){
    this.getExpensesList()
    }
    
    getExpensesList = async () =>{    getExpenseFormList().then((response) => {
        let dropdownOptions = []
        let provFormName = ""
        let prevUsername = ""
        let formName = this.state.formName
        if (Array.isArray(response)) {
            response.map(entry =>{
                prevUsername = `${entry.username}`
                provFormName =  `${entry.username} ${moment().format("MM-YYYY")} Expenses`,
                dropdownOptions.push({key: entry.id, text: entry.title, value: entry.id})
            })   
        }
        formName = formName ? formName : provFormName
        this.setState({dropdownOptions:dropdownOptions.reverse(), expenseFormList: response.reverse(),loading:false,formName:formName,username:prevUsername})
    })}
    updateTableEntries = (index, arrPos, value) =>{
        let newTableEntries = [...this.state.tableEntries]
        newTableEntries[index][arrPos] = value
        
        // calculate totals
        let newTotals = [...this.state.totals] 
        if("3456".includes(arrPos)){
            let TotalToChange = 0
            newTableEntries.map((entry) => {
                TotalToChange += Number(entry[arrPos])
            })
            newTotals[arrPos] = TotalToChange        
        }

        //3 - train  4 - parking  5 - mileage  7 - other
        //
        this.setState({tableEntries:newTableEntries,totals:newTotals,unsaved:true})
    }
    
    deleteForm = async () =>{
       
        if(this.state.formID == this.state.currentSelection){
            window.alert("Can't delete currently loaded form. Select another form to delete.")
        }
        else {
            this.setState({loading:true})
        let response = await deleteExpenseForm(this.state.currentSelection)
        if (response.success) {
            this.setState({currentSelection:undefined})
            await this.getExpensesList()
            this.setState({loading:false})
        }}
    }
 
 
        loadForm = async () =>{
        this.setState({loading:true})
            let formID = this.state.currentSelection
            let formToLoad = this.state.expenseFormList.find(obj => obj.id === formID);
            if (formToLoad){
                for (const entry of formToLoad.table_entries) {
                    if (Array.isArray(entry[7])) {
                        for (let entrIndex = 0; entrIndex < entry[7].length; entrIndex++) {
                            let response = await getExpenseImage(entry[7][entrIndex].client_id);
                            entry[7][entrIndex].dataUrl = response.file; 
                        }
                    } else {
                        if (entry[7]) {
                            let response = await getExpenseImage(entry[7].client_id);
                            entry[7].dataUrl = response.file;
                          }
                    }
                    if (Array.isArray(entry[8])) {
                        for (let entrIndex = 0; entrIndex < entry[8].length; entrIndex++) {
                            let response = await getExpenseImage(entry[8][entrIndex].client_id);
                            entry[8][entrIndex].dataUrl = response.file; 
                        }
                    } else {
                        if (entry[8]) {
                            let response = await getExpenseImage(entry[8].client_id);
                            entry[8].dataUrl = response.file;
                          }
                    }
                    if (Array.isArray(entry[9])) {
                        for (let entrIndex = 0; entrIndex < entry[9].length; entrIndex++) {
                            let response = await getExpenseImage(entry[9][entrIndex].client_id);
                            entry[9][entrIndex].dataUrl = response.file; 
                        }
                    } else {
                        if (entry[9]) {
                            let response = await getExpenseImage(entry[9].client_id);
                            entry[9].dataUrl = response.file;
                          }
                    }
                  }
                await this.getExpensesList()
                
                let newTotals = [...this.state.totals] 
                let indexes = [3,4,5,6]
                indexes.map((arrPos) => {
                    let TotalToChange = 0
                    formToLoad.table_entries.map((entry) => {
                        TotalToChange += Number(entry[arrPos])
                    })
                    newTotals[arrPos] = TotalToChange      
                })
                
                this.setState({loading:false,monthConfirmed:true,formID:this.state.currentSelection,dateRange:formToLoad.date_range,formName:formToLoad.title,tableEntries:formToLoad.table_entries,totals:newTotals,filesToUpload:[]})
            }

    }
    saveForm = async () =>{
        this.setState({loading:true})
        let tableEntryData = JSON.parse(JSON.stringify(this.state.tableEntries));
        let formData = {form_id:this.state.formID,table_entries:tableEntryData, title:this.state.formName,date_range:this.state.dateRange}
        let response = await uploadExpenseForm(formData)
            
      this.setState({formID:response.formId,unsaved:false, })

        await this.getExpensesList()
        
    }
    
     removeFileByClientId(client_id) {

      let  newFilesToUpload = [...this.state.filesToUpload]
        const index = newFilesToUpload.findIndex(item => item.client_id === client_id);

        if (index !== -1) {
          newFilesToUpload.splice(index, 1);
        }
       return newFilesToUpload
      }
      
      
    displayArrPics(entries,tableEntryIndex,arrPos) {
       return <div>{entries.map((entry,index)=>{return <div><div style={{textAlign:"center"}}><img style={{ objectFit: "cover",width:"100px",height:"100px"}} src={entry["dataUrl"]} alt="Preview" /><br/><Button onClick={()=>{this.removeFileFromEntry(tableEntryIndex,arrPos,index)}}>Delete</Button></div><br/></div>})}</div>
      }

    addFileToEntry = (index, arrPos, file) =>{
        let newTableEntries = [...this.state.tableEntries]
        let filesToUpload = [...this.state.filesToUpload]
        if(file){
            if(!Array.isArray(newTableEntries[index][arrPos])) {
                newTableEntries[index][arrPos] = [...newTableEntries[index][arrPos]]
            }
            let client_id = uuidv1()
            if (file.type === 'application/pdf') {
                this.setState({pdfNotif:true})
            }
            newTableEntries[index][arrPos].push({client_id:client_id,dataUrl:file.type === 'application/pdf' ? fileIcon : URL.createObjectURL(file)})
            this.uploadExpenseImage({client_id:client_id,file:file},[index,arrPos,newTableEntries[index][arrPos].length-1])
            
        }
        this.setState({tableEntries:newTableEntries,filesToUpload:filesToUpload,unsaved:true})
    }

    uploadExpenseImage= async (fileToUpload,locationInTable) =>{
this.setState({uploadError:undefined})
          const imageFormData = new FormData();
        imageFormData.append("id", fileToUpload.client_id);
        imageFormData.append("file",fileToUpload.file);
        let response = await uploadExpenseImages(imageFormData)  
        if (!response.success){
            this.setState({uploadError:{message:response.statusMessage,dismissButton:() =>{this.setState({uploadError:undefined});this.removeFileFromEntry(locationInTable[0],locationInTable[1],locationInTable[2])},uploadFile:[fileToUpload,locationInTable]}})

         } else {
            this.setState({uploadError:undefined})
         }
    }
    
    removeFileFromEntry = (index, arrPos, arrIndex) =>{
        let newTableEntries = [...this.state.tableEntries]
        let filesToUpload = [...this.state.filesToUpload]
        let client_id = newTableEntries[index][arrPos][arrIndex]["client_id"]
        filesToUpload = this.removeFileByClientId(client_id)
        newTableEntries[index][arrPos].splice(arrIndex,1)
        this.setState({tableEntries:newTableEntries,filesToUpload:filesToUpload,unsaved:true,uploadError:undefined})
    }
    
    handleExpensesImage = async () =>{
        html2canvas(document.querySelector("#expTable")).then(async canvas => {
            this.setState({isDownloading:true,showDownload:true});
            const fileName = `${this.state.username} ${this.state.dateRange.split("-").reverse().join("_")} Expenses.png`;
            await handleFileDownload(canvas.toDataURL('image/png'),fileName);
            this.setState({isDownloading:false});
        })
    }

    handleExpensesDownload = async () => {
        this.setState({isDownloading:true,showDownload:true});
        const URL = BASE_URL+"/export/expense_form/"+this.state.formID;
        const fileName =  `${this.state.username} ${this.state.dateRange.split("-").reverse().join("_")} Expenses.xlsx`;
        await handleFileDownload(URL,fileName);
        this.setState({isDownloading:false});
    };
    updateTotals = () =>{
        let newTotals = [...this.state.totals] 
        let indexes = [3,4,5,6]
        indexes.map((arrPos) => {
            let TotalToChange = 0
            this.state.tableEntries.map((entry) => {
                TotalToChange += Number(entry[arrPos])
            })
            newTotals[arrPos] = TotalToChange      
        })
        this.setState({totals:newTotals,unsaved:true})
    }
    deleteTableEntry = (index) =>{
        let newTableEntries = [...this.state.tableEntries]
        newTableEntries.splice(index,1)
        this.setState({tableEntries:newTableEntries},this.updateTotals)
    }
    
    dupeTableEntry = (index) =>{
        let newTableEntries = [...this.state.tableEntries]
        let entryToDupe = [...newTableEntries[index]]
        entryToDupe[7] = []
        entryToDupe[8] = []
        entryToDupe[9] = []
        newTableEntries.splice(index+1,0,entryToDupe)
        this.setState({tableEntries:newTableEntries},this.updateTotals)
    }
    joinAbove = (index) =>{
        let newTableEntries = [...this.state.tableEntries]
        let entryToSplice = newTableEntries.splice(index,1)[0]
        newTableEntries[index - 1][1] += entryToSplice[1]
        newTableEntries[index - 1][2] += entryToSplice[2]
        newTableEntries[index - 1][3] =Number(newTableEntries[index - 1][3]) + Number((entryToSplice[3] ||0))
        newTableEntries[index - 1][4] =Number(newTableEntries[index - 1][4]) + Number((entryToSplice[4] ||0))
        newTableEntries[index - 1][5] =Number(newTableEntries[index - 1][5]) + Number((entryToSplice[5] ||0))
        newTableEntries[index - 1][6] =Number(newTableEntries[index - 1][6]) + Number((entryToSplice[6] ||0))
        newTableEntries[index - 1][7] = [...newTableEntries[index - 1][7], ...entryToSplice[7]]
        newTableEntries[index - 1][7] = [...newTableEntries[index - 1][8], ...entryToSplice[8]]
        newTableEntries[index - 1][7] = [...newTableEntries[index - 1][9], ...entryToSplice[9]]
        this.setState({tableEntries:newTableEntries},this.updateTotals) 
    }
    
    moveTableEntry = (index,moveUp) =>{
        let newTableEntries = [...this.state.tableEntries]
        let entryToMove = newTableEntries.splice(index,1)[0]
        if(moveUp){
            newTableEntries.splice(index-1,0,entryToMove)
        } else{
            newTableEntries.splice(index+1,0,entryToMove)
        }
        this.setState({tableEntries:newTableEntries,unsaved:true})
    }

    pullMonthlyPVs = () =>{
        this.setState({loadingInspections:true})
            const [year, month] = this.state.dateRange.split('-').map(Number);
            const startDate = new Date(Date.UTC(year, month - 1, 1, 0, 0, 0)).toISOString(); 
            const lastDayOfMonth = new Date(Date.UTC(year, month, 0)).getUTCDate();
            const endDate = new Date(Date.UTC(year, month - 1, lastDayOfMonth, 23, 59, 59, 999)).toISOString(); 
            getPropertyVisitsByDate(PROPERTY_VISIT_API_URL, startDate, endDate).then((response)=>{
                let entriesToAdd = []
                if (response) {
                let sortedInspections = response  .filter(pv => pv.status !== "pending" && pv.status !== "cancelled").sort((a, b) => new Date(a.visit_date) - new Date(b.visit_date));
                sortedInspections.map(insp =>{
                    entriesToAdd.push([moment(insp.visit_date).format("DD/MM/YYYY"),insp.address,`${insp.company} ${insp.status.toUpperCase()}`,0,0,0,0])
                })
            }
                let newTableEntries = [...this.state.tableEntries,...entriesToAdd]
                this.setState({tableEntries:newTableEntries,loadingInspections:false,inspectionLoadFinished:true,unsaved:true})
            })
        }
    pullMonthlyInspections = () =>{
        this.setState({loadingInspections:true})
            const [year, month] = this.state.dateRange.split('-').map(Number);
            const startDate = new Date(Date.UTC(year, month - 1, 1, 0, 0, 0)).toISOString(); 
            const lastDayOfMonth = new Date(Date.UTC(year, month, 0)).getUTCDate();
            const endDate = new Date(Date.UTC(year, month - 1, lastDayOfMonth, 23, 59, 59, 999)).toISOString(); 
            getInspectionByDate(DASHBOARD_API_URL, startDate, endDate).then((response)=>{
                let entriesToAdd = []
                if (response.inspections) {
                let sortedInspections = response.inspections.sort((a, b) => new Date(a.inspection_start_time) - new Date(b.inspection_start_time));
                sortedInspections.map(insp =>{
                    entriesToAdd.push([moment(insp.inspection_time.inspection_date).format("DD/MM/YYYY"),insp.property.address,`${insp.company_name} ${insp.status.toUpperCase()}`,0,0,0,0])
                })
            }
                let newTableEntries = [...this.state.tableEntries,...entriesToAdd]
                this.setState({tableEntries:newTableEntries,loadingInspections:false,inspectionLoadFinished:true,unsaved:true})
            })
        }
    render() {


        return <Segment  className="pad-top">
            <Form>
                <Grid className="soc-grid" stackable columns={2}>
                    <Grid.Row>
                        <Grid.Column width={16}><Header size='large' textAlign='center' className="icon-button">Clerk Expenses Generator</Header>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                        <Message>
 <Message.List>
<Message.Header>
         The Clerk Expenses Generator allows you to pull all the inspections for a given month into the form automatically, and add receipts directly as well, save to the server and export to excel.<br/> <p><strong>NOTE:</strong> You still need to send the exported excel file to accounts@hinchpm.com</p>
    </Message.Header>
<p>
    Please refer to the tutorial video for further details: <a href="https://youtu.be/fYFvzawBnAI">https://youtu.be/fYFvzawBnAI</a></p>
<p>
        Also please refer to the below information on our remittance / expenses process
</p>

<strong>REMITTANCES:</strong>
<Message.Item>Remittances are sent out after month's end, with all the jobs done the previous month.</Message.Item>
<Message.Item> Weekend jobs have £5 fee added by default.</Message.Item>
<Message.Item> Travel Charges should appear on the added fee in the remittance and should never go on your expenses, if you do not find a travel charge in the added fee section, please let us know, never add it to your expenses unless explicitly stated by a member of staff to do so.</Message.Item>
<Message.Item> Please note Travel Charges are not automatic and must always be agreed with Bookings, even when a job passes a certain mileage threshold, (£10 for 50mi+ / £15 for 60mi+),they must still be agreed, as the job volume on that particular day/area needs to be taken into account.</Message.Item>
<Message.Item> The remittance PDF's “pay amount” column shows only the base pay as per the price list, any agreed extra charges will show on the “Added Fee column.” Sometimes the base pay will be 0 and the full pay amount will be only on the added fees column.</Message.Item>
<Message.Item> Check In reports with report type "New" will be paid as Inventory/Check in price (Refer to the pay scheme)</Message.Item>

<strong>EXPENSES:</strong>
<Message.Item> Send in your expenses before the 5th, include only jobs for the previous month (1st to 30th/31st), do not include Travel Charges (those should be visible in "Added Fee" column on the remittance PDF.)</Message.Item>
<Message.Item> For gas mileage, it is 15p per mile.</Message.Item>
<Message.Item> If the distance covered is a lot larger that one would expect by simply taking the direct GPS route witch concessions for key collection from the agent and the like, please explain the reason why</Message.Item>
<Message.Item> If expenses are received after the 5th they may only be paid the following month</Message.Item>
<Message.Item> Include all receipts in the "Receipts" sheet of the expenses template, failure to do so will delay the payment</Message.Item>
<Message.Item> If using a typist, where Hinch has agreed to cover the cost for a given period, you must pay their invoice once you receive it, then include the invoice and the reimbursement amount in your next expenses sheet</Message.Item>
<Message.Item> Expenses sent in 2+ months late are liable not to be paid</Message.Item>
<Message.Item> Use the expenses generator or alternatively the following expenses form: https://www.hinchpm.com/wp-content/uploads/2022/06/Clerk-Accounting.zip</Message.Item>
<Message.Item> Send the file in as an excel, do not PDF, if using iCloud numbers, export to excel when saving</Message.Item>
<Message.Item> Expenses usually get paid 1 day before remittance (subject to change), remittances usually get paid on the 10th (or last working day before)</Message.Item>

                   </Message.List>     </Message>
</Grid.Column>
                        
                    </Grid.Row>
                    <Grid.Row>
                    <Grid.Column>
                            <Segment>
                                <Header align="center">Month & Year</Header>
                                <div style={{textAlign:"center"}}>
                                <Form.Input style={{width:"200px",margin:"auto"}}
                                type="month"
                                    value={this.state.dateRange}
                                    onChange={(e, option) => {
                                        
                                        if( !this.state.monthConfirmed){this.setState({dateRange:option.value,formName:`${this.state.username} ${option.value.split("-").reverse().join("_")} Expenses`})}
                                        
                                    }} />
                                     {this.state.monthConfirmed && <Message>Date Selection Locked</Message>}
                                        {this.state.inspectionLoadFinished && <Message>Inspections loaded, only add inspections for the above month onto this sheet. Do not mix PVs and Inspections, please make separate forms for each.</Message>}
                                        <br></br>
                                        {this.state.monthConfirmed && !this.state.inspectionLoadFinished && <Button type="button" loading={this.state.loadingInspections} disabled={!this.state.dateRange|| this.state.loadingInspections|| this.state.inspectionLoadFinished || !this.state.monthConfirmed} onClick={()=>{this.pullMonthlyInspections()}}>Add Monthly Inspections To Table</Button>}
                                        {this.state.monthConfirmed && !this.state.inspectionLoadFinished && <Button type="button" loading={this.state.loadingInspections} disabled={!this.state.dateRange|| this.state.loadingInspections|| this.state.inspectionLoadFinished || !this.state.monthConfirmed} onClick={()=>{this.pullMonthlyPVs()}}>Add Monthly PVs To Table</Button>}
                                    {!this.state.monthConfirmed && <Button disabled={!this.state.dateRange}onClick={()=>{this.setState({monthConfirmed:true})}}>Confirm Month & Year</Button>}
                                    </div>       
                            </Segment>
                        </Grid.Column>
                        <Grid.Column>
                        <Segment>
                        <Header>Form ID <Button circular compact basic> {this.state.formID || "Not Saved"}</Button></Header>
                             <div style={{textAlign:"center"}}>
                              {this.state.monthConfirmed &&  <div><Header align="center">{!this.state.formID ? "Save Form" :"Update Form"}</Header>
                              {this.state.unsaved && <span style={{color:"red"}}>You have unsaved changes</span>}
                              {this.state.imageUpload && <span style={{color:"red"}}>Uploading Image {this.state.currentImageCount} of  {this.state.filesToUpload.length}</span>}
                                <Form.Group style={{textAlign:"center"}}>
                               <Form.Input value={this.state.formName} onChange={(e) =>{this.setState({formName:e.target.value})}} inline label="Form Name"></Form.Input>
                                <Button  loading={this.state.loading}disabled={(this.state.tableEntries < 1)|| this.state.loading}onClick={()=>{this.saveForm()}}>{!this.state.formID ? "Save New Form" :"Update Form"} </Button>
                                </Form.Group>   
                                </div>}
                                <Divider></Divider>
                                <Header align="center">Load Form</Header>
                                <Form.Group>
                                <Form.Field inline>
                                    <label>Select Form</label>
                                <Dropdown selection inline
                placeholder="Not Defined"
                options={this.state.dropdownOptions}
                defaultValue={undefined}
                onChange={(e, option) => {this.setState({currentSelection:option.value})
                }}>   
              </Dropdown>
              <Button style={{marginLeft:"10px"}} loading={this.state.loading}onClick={()=>{this.loadForm()}} disabled={!this.state.currentSelection || this.state.loading}> Load Form</Button>   
               <Popup on="click" trigger={<Button style={{marginLeft:"10px"}}  loading={this.state.loading}disabled={!this.state.currentSelection || this.state.loading}> Delete Form</Button>}>Confirm Form Deletion? <Button color="red"disabled={!this.state.currentSelection || this.state.loading} onClick={()=>{this.deleteForm()}}>Delete</Button></Popup></Form.Field>
                                </Form.Group>
                                <Divider></Divider>
                                {this.state.formID && <div>
                                <Header align="center">Export Form</Header>
                                <Button onClick={()=>{this.handleExpensesDownload()}}>Export To Excel</Button>
                                <Button onClick={()=>{this.handleExpensesImage()}}>Export As Image</Button>
                                    </div>}
                            </div>
                        </Segment>
                        </Grid.Column>
                    </Grid.Row>
                    </Grid>
                    <Segment>
                        <Header style={{textAlign:"center"}}>
                    <strong>TOTALS</strong>
                    <Label basic>Train Tickets<LabelDetail>£{Number(Math.round(this.state.totals[3] * 100) / 100)}</LabelDetail></Label>
                    <Label basic >Parking<LabelDetail>£{Number(Math.round(this.state.totals[4] * 100) / 100)}</LabelDetail></Label>
                    <Label basic>Mileage<LabelDetail>{Number(Math.round(this.state.totals[5] * 100) / 100)} Miles</LabelDetail></Label>
                    <Label basic>Mileage (£)<LabelDetail>£{Number(Math.round(this.state.totals[5]*0.15 * 100) / 100)}</LabelDetail></Label>
                    <Label basic>Other<LabelDetail>£{Number(Math.round(this.state.totals[6] * 100) / 100)}</LabelDetail></Label>
                    <Label basic color="blue">Expenses Total<LabelDetail>
                        £{Number(Math.round((this.state.totals[3]+this.state.totals[4]+this.state.totals[5]*0.15+this.state.totals[6] )* 100) / 100)}
                        </LabelDetail></Label>
                    </Header>
                    </Segment>
                    {this.state.pdfNotif &&   <Message negative>
                                    <Message.Header>PDF Attached</Message.Header>
                                    <p>Only the first page of a PDF will be uploaded and converted to an image, the rest will be discarded. If you need to upload a longer PDF, google "Convert PDF to long image"</p>
                                </Message>}
                                {this.state.uploadError &&<div
                        style={{ position: "fixed", bottom: "20px", left: "50%", transform: "translateX(-50%)",
                            zIndex: 1000, 
                            width: "auto", 
                        }}
                        >  <Message negative>
                                    <Message.Header>File Upload Error</Message.Header>
                                    <p>The image / PDF upload has file with the following error message ${this.state.uploadError.message}</p><p>
                                        <Button onClick={this.state.uploadError.dismissButton }>Dismiss</Button><Button onClick={()=>{this.uploadExpenseImage(...this.state.uploadError.uploadFile)}}>Retry</Button>
                                    </p>
                                </Message></div>}
                    <Segment id="expTable">
                        <Table compact celled striped>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Date</Table.HeaderCell>
                                    <Table.HeaderCell>Address / Item</Table.HeaderCell>
                                    <Table.HeaderCell>Notes</Table.HeaderCell>
                                    <Table.HeaderCell>Train Tickets</Table.HeaderCell>
                                    <Table.HeaderCell>Parking</Table.HeaderCell>
                                    <Table.HeaderCell>Mileage</Table.HeaderCell>
                                    <Table.HeaderCell>Mileage (£)</Table.HeaderCell>
                                    <Table.HeaderCell>Other / Misc</Table.HeaderCell>
                                    <Table.HeaderCell>Total</Table.HeaderCell>
                                    <Table.HeaderCell>Action</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {this.state.tableEntries.map((entry, index) =>{
                                    return <React.Fragment key={index}><Table.Row>
                                    <Table.Cell style={{textAlign:"center"}}><Form.Input onChange={e=>{this.updateTableEntries(index,0,e.target.value)}} style={{width:"130px"}} value={entry[0]}></Form.Input></Table.Cell>
                                    <Table.Cell style={{textAlign:"center"}}><Form.Input onChange={e=>{this.updateTableEntries(index,1,e.target.value)}}value={entry[1]}></Form.Input></Table.Cell>
                                    <Table.Cell style={{textAlign:"center"}}><Form.Input onChange={e=>{this.updateTableEntries(index,2,e.target.value)}}value={entry[2]}></Form.Input></Table.Cell>
                                    <Table.Cell style={{textAlign:"center"}}><Form.Input onChange={e=>{this.updateTableEntries(index,3,e.target.value)}}style={{width:"85px"}}inline label="£"type="number" min="0" step="0.01" value={entry[3]}></Form.Input></Table.Cell>
                                    <Table.Cell style={{textAlign:"center"}}><Form.Input onChange={e=>{this.updateTableEntries(index,4,e.target.value)}}style={{width:"85px"}}inline label="£"type="number" min="0" step="0.01" value={entry[4]}></Form.Input></Table.Cell>
                                    <Table.Cell style={{textAlign:"center"}}><Form.Input onChange={e=>{this.updateTableEntries(index,5,e.target.value)}}style={{width:"85px"}}inline label="Miles"type="number" min="0" step="0.01"value={entry[5]}></Form.Input></Table.Cell>
                                    <Table.Cell style={{textAlign:"center"}}>£{Number(Math.round(entry[5]*0.15 * 100) / 100)}</Table.Cell>
                                    <Table.Cell style={{textAlign:"center"}}><Form.Input onChange={e=>{this.updateTableEntries(index,6,e.target.value)}} style={{width:"85px"}}inline label="£"type="number" min="0" step="0.01" value={entry[6]}></Form.Input></Table.Cell>
                                    <Table.Cell style={{textAlign:"center"}}>£{Math.round((Number(entry[3]) + Number(entry[4]) + Number(entry[5]*0.15) + Number(entry[6]))*100)/100}</Table.Cell>
                                <Table.Cell>
                                    <div style={{textAlign:"center"}}>
                                    <Button basic compact icon color="gray" onClick={()=>{this.dupeTableEntry(index)}}><Icon name="copy"/></Button>
                                    <Popup on="click"trigger={<Button disabled={index == 0}basic compact icon color="gray" ><Icon name="arrow up"/><Icon name="plus"/></Button>}><strong>Join with above row?</strong> <Button onClick={()=>{this.joinAbove(index)}} >Confirm</Button></Popup>
                                    <Popup on="click"trigger={ <Button basic compact icon color="red" ><Icon name="close"/></Button>}><strong>Delete Row?</strong> <Button onClick={()=>{this.deleteTableEntry(index)}}>Confirm</Button></Popup>
                                    <Button basic compact icon color="blue" disabled={index===0} onClick={()=>{this.moveTableEntry(index,true)}}><Icon name="arrow up"/></Button>
                                    <Button basic compact icon color="blue" disabled={index===this.state.tableEntries.length-1} onClick={()=>{this.moveTableEntry(index,false)}}><Icon name="arrow down"/></Button>
                                    </div>
                                    </Table.Cell>
                                </Table.Row>
                                {(entry[3] > 0 || entry[4] > 0 ||entry[6] > 0) &&<React.Fragment><Table.Row>
                                    <Table.Cell style={{textAlign:"right"}} colSpan={3}><strong>Receipts</strong> </Table.Cell>
                                    <Table.Cell>
                                     {entry[3] > 0 &&<div>
                                        {Array.isArray(entry[7]) ? this.displayArrPics(entry[7],index,7):undefined}
                                        <Form.Field  inline><Form.Input style={{width:"115px"}} type="file" accept="image/*,application/pdf"onChange={e=>this.addFileToEntry(index,7,e.target.files[0])} /></Form.Field>
                                     </div>}</Table.Cell>
                                     <Table.Cell>
                                     {entry[4] > 0 &&<div>
                                        {Array.isArray(entry[8]) ? this.displayArrPics(entry[8],index,8):undefined}
                                        <Form.Field  inline><Form.Input style={{width:"115px"}} type="file" accept="image/*,application/pdf"onChange={e=>this.addFileToEntry(index,8,e.target.files[0])} /></Form.Field>
                                     </div>}</Table.Cell>
                                    <Table.Cell/>
                                    <Table.Cell/>
                                    <Table.Cell>   
                                    {entry[6] > 0 &&<div>
                                        {Array.isArray(entry[9]) ? this.displayArrPics(entry[9],index,9):undefined}
                                        <Form.Field  inline><Form.Input style={{width:"115px"}} type="file" accept="image/*,application/pdf"onChange={e=>this.addFileToEntry(index,9,e.target.files[0])} /></Form.Field>
                                     </div>}</Table.Cell>
                                   <Table.Cell/>
                                    <Table.Cell/>
                              </Table.Row><Table.Row>
                                <Table.HeaderCell colSpan={10}><div >&#8203;</div></Table.HeaderCell></Table.Row></React.Fragment>
                                }
                                </React.Fragment>
                                })}
                            </Table.Body>
                            <Table.Footer>
                            <Table.Row>
                            <Table.HeaderCell colSpan={3}><div style={{textAlign:"right"}}><strong>TOTALS</strong></div></Table.HeaderCell>
                                    <Table.HeaderCell style={{textAlign:"center"}}>£{Number(Math.round(this.state.totals[3] * 100) / 100)}</Table.HeaderCell>
                                    <Table.HeaderCell style={{textAlign:"center"}}>£{Number(Math.round(this.state.totals[4] * 100) / 100)}</Table.HeaderCell>
                                    <Table.HeaderCell style={{textAlign:"center"}}>{Number(Math.round(this.state.totals[5] * 100) / 100)} Miles</Table.HeaderCell>
                                    <Table.HeaderCell style={{textAlign:"center"}}>£{Number(Math.round(this.state.totals[5]*0.15 * 100) / 100)}</Table.HeaderCell>
                                    <Table.HeaderCell style={{textAlign:"center"}}>£{Number(Math.round(this.state.totals[6] * 100) / 100)}</Table.HeaderCell>
                                    <Table.HeaderCell>£{Number(Math.round((this.state.totals[3]+this.state.totals[4]+this.state.totals[5]*0.15+this.state.totals[6] )* 100) / 100)}</Table.HeaderCell>
                                    <Table.HeaderCell></Table.HeaderCell>
                            </Table.Row>
                                <Table.Row>
                                    <Table.Cell colSpan={10}>
                                    <div style={{textAlign:"center"}}>
                                    <Button onClick={()=>{this.setState({unsaved:true,tableEntries:[...this.state.tableEntries,["","","",0,0,0,0,[],[],[]]]})}}>Add Row</Button>
                                        </div>
                                        </Table.Cell>
                                </Table.Row>
                                </Table.Footer>
                        </Table>
                        </Segment>
            </Form>
            {this.state.showDownload && <DownloadingIntent isDownloading={this.state.isDownloading}/>}
      </Segment>
  }
}




// WEBPACK FOOTER //
// ./src/views/report/expenses_generator/expenses_generator.js